const $$splitComponentImporter = () => import('/app/src/routes/register.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/register")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: (typeof search.redirect === "string" ? search.redirect : "") as string
  })
});

/* --- Social Icons --- */